import React from "react";

import "./FloatingField.css"

export default function FloatingField({label, children})
{
	// La label va omessa del tutto quando è vuota (caso dei campi annidati in
	// .product-field-actions-wrap, che la label ce l'hanno già sul wrapper esterno): un <b> vuoto
	// resta comunque un box inline con `padding-left: 11px`, e siccome non contiene caratteri non
	// offre alcun punto di a-capo al controllo che segue (input/textarea sono inline-block). Il
	// controllo resta quindi sulla stessa riga, spinto a destra di 11px: rientro a sinistra e
	// sbordamento a destra rispetto al bordo del campo.
	return (
		<div className="floating-field">
			{label ? <b><em>{label}</em></b> : null}
			{children}
		</div>
	);
}
